"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function escapeForRegex(string) {
    var res = string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    return res;
}
var applyToBracketedExpressions = function (apply, openingBracketChar, closingBracketChar) {
    if (openingBracketChar === void 0) { openingBracketChar = '{'; }
    if (closingBracketChar === void 0) { closingBracketChar = '}'; }
    return function (expression) {
        // const rx = /(?<!\\)(?:\\\\)*{([^((?<!\\)(?:\\\\)*{)(?<!\\)(?:\\\\)*}]*)(?<!\\)(?:\\\\)*}/gm
        // capture what's in curly brackets, and contains no unescaped curly brackets
        /*
        The below works perfectly, but lookbehind isn't supported in all browsers yet.
        const rx = new RegExp(
            `(?<!\\\\)(?:\\\\\\\\)*${openingBracketChar}([^((?<!\\\\)(?:\\\\\\\\)*${openingBracketChar})(?<!\\\\)(?:\\\\\\\\)*${closingBracketChar}]*)(?<!\\\\)(?:\\\\\\\\)*${closingBracketChar}`,
            'gm',
        );
        const evald = expression.replace(rx, (a, b) => {
            return apply(b);
        });
        */
        var reverse = function (s) {
            if (!s && typeof s !== 'number') {
                return s;
            }
            return String(s)
                .split('')
                .reverse()
                .join('');
        };
        var reverseRx = new RegExp(
        // >>(?!\\)(?:\\\\)*((?:(?!<<).)*)<<(?!\\\\)(?:\\\\)*
        // In this example we don't ever expect to see << or >> within our target, so if that's the case, it's okay.
        "".concat(escapeForRegex(reverse(closingBracketChar)), "(?!\\\\)(?:\\\\\\\\)*((?:(?!").concat(escapeForRegex(reverse(openingBracketChar)), "|").concat(escapeForRegex(reverse(closingBracketChar)), ").)*)").concat(escapeForRegex(reverse(openingBracketChar)), "(?!\\\\\\\\)(?:\\\\\\\\)*"), 
        // there is escaping related stuff below, but it is causing problems.
        // `${closingBracketChar}(?!\\\\)(?:\\\\\\\\)*([^${closingBracketChar}(?!\\\\)(?:\\\\\\\\)*(${openingBracketChar}(?!\\\\)(?:\\\\\\\\)*)]*)${openingBracketChar}(?!\\\\)(?:\\\\\\\\)*`,
        'gm');
        var evald = reverse(reverse(expression).replace(reverseRx, function (a, b) {
            // need to apply the original to our function, and reverse the result when it is inlined
            return reverse(apply(reverse(b)));
        }));
        var escapedOpenings = new RegExp("(?:\\\\)*".concat(escapeForRegex(openingBracketChar)), 'gm');
        var escapedClosings = new RegExp("(?:\\\\)*".concat(escapeForRegex(closingBracketChar)), 'gm');
        var withEscapedBracketsInserted = evald
            .replace(escapedOpenings, openingBracketChar)
            .replace(escapedClosings, closingBracketChar);
        return withEscapedBracketsInserted;
    };
};
exports.default = applyToBracketedExpressions;
//# sourceMappingURL=index.js.map